import * as yup from "yup";

const requiredMessage: string = 'Ce champ est obligatoire et doit être rempli.';
const maxMessage: string = 'Cette information doit faire moins de 191 caractères.'

export const resetPasswordSchema = yup.object().shape({
    email: yup.string().nullable()
        .required(requiredMessage)
        .email('Veuillez ressaisir une adresse email valide.')
        .max(191, maxMessage)
})